var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreVertical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 4.98C9 3.336 10.34 2 12 2c1.654 0 3 1.337 3 2.98 0 1.642-1.346 2.978-3 2.978S9 6.622 9 4.98Zm4.266.006c0-.692-.57-1.257-1.266-1.257-.696 0-1.266.565-1.266 1.257 0 .691.57 1.257 1.266 1.257.696 0 1.266-.566 1.266-1.257ZM12 9.488c-1.66 0-3 1.336-3 2.979 0 1.642 1.346 2.979 3 2.979s3-1.337 3-2.98c0-1.642-1.346-2.978-3-2.978Zm0 1.729c.696 0 1.266.565 1.266 1.256 0 .692-.57 1.257-1.266 1.257a1.264 1.264 0 0 1-1.266-1.257c0-.691.57-1.256 1.266-1.256ZM12 17.042c-1.66 0-3 1.336-3 2.979C9 21.663 10.346 23 12 23s3-1.337 3-2.98c0-1.642-1.346-2.978-3-2.978Zm0 1.729c.696 0 1.266.565 1.266 1.257 0 .691-.57 1.256-1.266 1.256a1.264 1.264 0 0 1-1.266-1.256c0-.692.57-1.257 1.266-1.257Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MoreVertical.5780e01eacb3a2eda8bd9437616b8687.svg";